import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { PanelsName } from 'app/enums/panels.enum';
import { Notification } from 'app/models/notification.interface';
import { NotificationService } from 'app/services/notification.service';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

@Component({
    selector     : 'notifications-panel',
    templateUrl  : './notifications-panel.component.html',
    styleUrls    : ['./notifications-panel.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NotificationsPanelComponent implements OnInit, OnDestroy {
    
    @Input() refreshPanelDataObservable: Observable<void>;

    panelNames = PanelsName;

    notiArray: Notification[];

    isLoading: boolean = false;
    @Output() loading: EventEmitter<boolean>;

    /**
     * Constructor
     */
    constructor(
        private router: Router,
        private fuseSidebarService: FuseSidebarService,
        private notificationService: NotificationService,
    ) {
        this.loading = new EventEmitter();
        this.notificationService.notifications$
          .subscribe(res => {
            res.map(x => {
                if(x.detail){
                    let complaintData = x.detail?.split('.')[1];
                    let newDatail = x.detail?.split('. [')[0];
                    complaintData?.split(' [');
                    // console.log(newDetail)
                    let arrComplaintData = complaintData?.split(' [');
                    if(arrComplaintData?.length > 0 ){
                        arrComplaintData?.map(y => {
                            console.log(y);
                            console.log(y.split(":")[1]);
                            if(y.includes('CODE_COMPLAINT')){
                                x.complaintCode = y.split(":")[1];
                            }else if(y.includes('COMPLAINT_TYPE')){
                                x.complaintType = y.split(":")[1];
                            }else if(y.includes('COMPLAINT_CLASSIFICATIONS')){
                                x.complaintClassification = y.split(":")[1];
                            }
                            console.log(x)
                        })
                    }
                    x.detail = newDatail;
                }
            });
            this.notiArray = res});
    }

    ngOnInit(): void {
        this.refreshPanelDataObservable
            .pipe(
                tap(() => this.setLoading(true)),
                switchMap(() => this.notificationService.getNotifications())
            )
            .subscribe(
                notifications => {
                    notifications.map(x => {
                        if(x.detail){
                            let complaintData = x.detail?.split('.')[1];
                            complaintData?.split(' [');
                            let newDatail = x.detail?.split('. [')[0];
                            let arrComplaintData = complaintData?.split(' [');
                            if(arrComplaintData?.length > 0 ){
                                arrComplaintData?.map(y => {
                                    console.log(y);
                                    console.log(y.split(":")[1]);
                                    if(y.includes('CODE_COMPLAINT')){
                                        x.complaintCode = y.split(":")[1];
                                    }else if(y.includes('COMPLAINT_TYPE')){
                                        x.complaintType = y.split(":")[1];
                                    }else if(y.includes('COMPLAINT_CLASSIFICATIONS')){
                                        x.complaintClassification = y.split(":")[1];
                                    }
                                })
                            }
                            x.detail = newDatail;
                        }
                    })
                    this.notiArray = notifications;
                    this.setLoading(false);
                },
                err => this.setLoading(false),
                () => this.setLoading(false)
            );
    }

    ngOnDestroy(): void {
        this.fuseSidebarService.getSidebar(this.panelNames.notificationPanel).close();
    }

    setLoading (is: boolean): void {
        this.isLoading = is;
        this.loading.emit(this.isLoading);
    }

    alertOpened(alert): void {
        alert.isDone = true;
        this.router.navigate([alert.url])
          .then(() => this.fuseSidebarService.getSidebar(this.panelNames.notificationPanel).toggleOpen());
        this.notificationService.readNotificationById(alert.id).subscribe(() => {});
    }

    handleNotification(item){
        if(item.notificationTypeId == 7 || item.notificationTypeId == 9){
            const ppFileId = item.url.split('/')[3];
            if(ppFileId){
                this.router.navigate(['pp-file-directory/visualization'], {state: {notification: true}});
                this.notificationService.readNotificationById(item.id).subscribe(() => {});
            }
        }else if(item.notificationTypeId == 8){
            this.router.navigate(['pp-file-directory/approver'], {state: {notification: true}});
            this.notificationService.readNotificationById(item.id).subscribe(() => {});
        }else{
            this.alertOpened(item);
        }
    }
}
